import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "portal-pager",
  "aria-label": "페이지 목록"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["aria-current", "onClick"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { computed } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PortalPager',
  props: {
    modelValue: {},
    totalPages: {},
    window: { default: 5 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const pages = computed(() => {
  const size = props.window
  let start = Math.max(1, props.modelValue - Math.floor(size / 2))
  const end = Math.min(props.totalPages, start + size - 1)
  start = Math.max(1, end - size + 1)
  const list: number[] = []
  for (let p = start; p <= end; p += 1) list.push(p)
  return list
})

function go(target: number) {
  const next = Math.min(Math.max(1, target), props.totalPages)
  if (next !== props.modelValue) emit('update:modelValue', next)
}

return (_ctx: any,_cache: any) => {
  return (__props.totalPages > 1)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "portal-pager__nav",
          disabled: __props.modelValue <= 1,
          "aria-label": "첫 페이지",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (go(1)))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-chevron-double-left",
            size: 18
          })
        ], 8, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "portal-pager__nav",
          disabled: __props.modelValue <= 1,
          "aria-label": "이전 페이지",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (go(__props.modelValue - 1)))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-chevron-left",
            size: 18
          })
        ], 8, _hoisted_3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (p) => {
          return (_openBlock(), _createElementBlock("button", {
            key: p,
            type: "button",
            class: _normalizeClass(["portal-pager__page", { 'is-active': p === __props.modelValue }]),
            "aria-current": p === __props.modelValue ? 'page' : undefined,
            onClick: ($event: any) => (go(p))
          }, _toDisplayString(p), 11, _hoisted_4))
        }), 128)),
        _createElementVNode("button", {
          type: "button",
          class: "portal-pager__nav",
          disabled: __props.modelValue >= __props.totalPages,
          "aria-label": "다음 페이지",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (go(__props.modelValue + 1)))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-chevron-right",
            size: 18
          })
        ], 8, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "portal-pager__nav",
          disabled: __props.modelValue >= __props.totalPages,
          "aria-label": "마지막 페이지",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (go(__props.totalPages)))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-chevron-double-right",
            size: 18
          })
        ], 8, _hoisted_6)
      ]))
    : _createCommentVNode("", true)
}
}

})